import { create } from 'zustand';

interface UiStore {
  isAuthModalOpen: boolean;
  authModalMessage?: string;
  showAuthModal: (message?: string) => void;
  hideAuthModal: () => void;
  isNotificationPreferencesOpen: boolean;
  showNotificationPreferencesModal: () => void;
  hideNotificationPreferencesModal: () => void;
}

export const useUiStore = create<UiStore>((set) => ({
  isAuthModalOpen: false,
  authModalMessage: undefined,
  showAuthModal: (message?: string) => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    set({ isAuthModalOpen: true, authModalMessage: message });
  },
  hideAuthModal: () => set({ isAuthModalOpen: false, authModalMessage: undefined }),
  isNotificationPreferencesOpen: false,
  showNotificationPreferencesModal: () => set({ isNotificationPreferencesOpen: true }),
  hideNotificationPreferencesModal: () => set({ isNotificationPreferencesOpen: false }),
}));

export function useAuthModal() {
  const isAuthModalOpen = useUiStore((s) => s.isAuthModalOpen);
  const authModalMessage = useUiStore((s) => s.authModalMessage);
  const showAuthModal = useUiStore((s) => s.showAuthModal);
  const hideAuthModal = useUiStore((s) => s.hideAuthModal);
  return { isAuthModalOpen, authModalMessage, showAuthModal, hideAuthModal };
}

export function useNotificationPreferencesModal() {
  const isNotificationPreferencesOpen = useUiStore((s) => s.isNotificationPreferencesOpen);
  const showNotificationPreferencesModal = useUiStore((s) => s.showNotificationPreferencesModal);
  const hideNotificationPreferencesModal = useUiStore((s) => s.hideNotificationPreferencesModal);
  return { isNotificationPreferencesOpen, showNotificationPreferencesModal, hideNotificationPreferencesModal };
}
